import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({ providedIn: "root" })
export class SnackbarService {
  constructor(private snackbar: MatSnackBar) {}

  success(message: string, dismiss: string = '') {
    this.snackbar.open(message, dismiss, {
        panelClass: ['mat-toolbar', 'mat-primary'],
        horizontalPosition: 'right',
        verticalPosition: 'top',
        duration: 3000
    })
  }

  error(message: string, dismiss: string = '') {
    this.snackbar.open(message, dismiss, {
        panelClass: ['mat-toolbar', 'mat-warn'],
        horizontalPosition: 'right',
        verticalPosition: 'top',
        duration: 3000
    })
  }
}
